import "flickity-imagesloaded";
import Flickity from "flickity";
import "flickity/css/flickity.css";

const galleries = document.querySelectorAll(".gallery__content");

const initGallery = (gallery) => {
  // eslint-disable-next-line no-unused-vars
  const flkty = new Flickity(gallery, {
    freeScroll: true,
    contain: true,
    imagesLoaded: true,
    prevNextButtons: true,
    pageDots: false,
    wrapAround: true,
    lazyLoad: 4,
    arrowShape:
      "M32.702 57.493L60.829 85.62 48.749 97.7 0 48.95 48.75.203l12.079 12.08-28.127 28.127H100v17.084z",
  });

  flkty.on("lazyLoad", (event, cellElement) => {
    const $img = cellElement.querySelector("img");

    if ($img) {
      $img.closest(".figure").style.width = `${
        $img.getBoundingClientRect().width
      }px`; // eslint-disable-line no-param-reassign
    }

    flkty.reloadCells();
  });
};

[...galleries].forEach((gallery) => initGallery(gallery));
